export default __webpack_public_path__ + "static/media/placeholder_store05-fr-mobile.562e1f6e.png";